enum Role {
  Owner = 1,
  Technician = 2,
  Manager = 3,
  Admin = 4
}

export default Role;
